var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"gakunenbtns2"},_vm._l((_vm.releasedContents),function(ref){
var month = ref[0];
return _c('v-col',{key:'month-' + month,staticClass:"month-col"},[_c('BaseButton',{staticClass:"gakunenbtn2",on:{"click":function($event){return _vm.moveMonth(month)}}},[_c('span',{staticClass:"gakunenbtn2__arrow"}),_vm._v(" "+_vm._s(parseInt(month.slice(4)))+"月号 ")])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }